import { Link } from "react-router-dom";
import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
}));

export const LogoLink = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  textDecoration: "none",
  transition: "all 0.2s ease",
  padding: "4px",
  borderRadius: "10px",
  
  "& > img": {
    width: "66px",
    height: "66px",
    borderRadius: "10px",
    objectFit: "contain",
    transition: "transform 0.3s ease",

    [theme.down("md")]: {
      width: "90px",
      height: "90px",
      borderRadius: "16px",
    },
  },

  "&:hover": {
    "& > img": {
      transform: "scale(1.05) rotate(-2deg)",
    },
  },
}));

export const LogoWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2px",

  [theme.down("sm")]: {
    display: "none",
  },
}));

export const LogoText = styled("span")(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 700,
  color: theme.palette.header.text,
  letterSpacing: "-0.02em",
  lineHeight: 1.2,

  [theme.down("md")]: {
    fontSize: "16px",
  },
}));

export const LogoSubtitle = styled("span")(({ theme }) => ({
  fontSize: "11px",
  fontWeight: 500,
  color: theme.palette.header.textSecondary,
  letterSpacing: "0.02em",
  lineHeight: 1,

  [theme.down("md")]: {
    fontSize: "10px",
  },
}));
